export default __webpack_public_path__ + "static/implied-motion-fab-light-fc5cfb6aaeff629149fc7f005e8ac2989ecdb29cce3a79c17edb008738a63328.mp4";